import BookingCollectionEmptyState from './BookingCollectionEmptyState';

export default BookingCollectionEmptyState;
